var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.71 6.13006C21.1 6.52006 21.1 7.15006 20.71 7.54006L18.88 9.37006L15.13 5.62006L16.96 3.79006C17.35 3.40006 17.98 3.40006 18.37 3.79006L20.71 6.13006ZM3 21.0001V17.9601C3 17.8201 3.05 17.7001 3.15 17.6001L14.06 6.69006L17.81 10.4401L6.89 21.3501C6.8 21.4501 6.67 21.5001 6.54 21.5001H3.5C3.22 21.5001 3 21.2801 3 21.0001Z",
    fill: "#017B5F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.4050070efc4eb52ec12f1b53f76ff202.svg";